module.exports = __webpack_public_path__ + "img/barcodeScanner.867aaad8.gif";